import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import ChartGlassPanel from '../../components/ChartGlassPanel';

const data = [
  { day: 'Mon', present: 40 },
  { day: 'Tue', present: 38 },
  { day: 'Wed', present: 42 },
  { day: 'Thu', present: 35 },
  { day: 'Fri', present: 40 },
];

export default function AttendanceAreaChart() {
  return (
    <ChartGlassPanel>
      <div className="w-full h-64">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 16, right: 24, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="attendanceColor" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#38bdf8" stopOpacity={0.7}/>
              <stop offset="95%" stopColor="#38bdf8" stopOpacity={0.1}/>
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="day" tick={{ fontSize: 14 }} />
          <YAxis allowDecimals={false} tick={{ fontSize: 14 }} />
          <Tooltip />
          <Area type="monotone" dataKey="present" stroke="#0ea5e9" fillOpacity={1} fill="url(#attendanceColor)" name="Present" />
        </AreaChart>
      </ResponsiveContainer>
    </div>
    </ChartGlassPanel>
  );
}
